const overlaySelector =
  '[role="dialog"], [role="alertdialog"], [data-slot="popover-content"]';

function isAvailable(element: HTMLElement) {
  return (
    !element.closest('[hidden], [inert], [aria-hidden="true"]') &&
    (typeof element.checkVisibility === "function"
      ? element.checkVisibility({ visibilityProperty: true })
      : element.getClientRects().length > 0 &&
        getComputedStyle(element).visibility === "visible")
  );
}

/** One document-level handler: hidden pages never compete for the shortcut. */
export function handleSearchShortcut(event: KeyboardEvent) {
  if (
    event.defaultPrevented ||
    event.isComposing ||
    event.altKey ||
    event.shiftKey ||
    !(event.metaKey || event.ctrlKey) ||
    event.key.toLowerCase() !== "k"
  ) {
    return;
  }

  const doc = document;
  const overlays = Array.from(
    doc.querySelectorAll<HTMLElement>(overlaySelector),
  ).filter(isAvailable);

  // Responsive page navigation may host the page search; local overlays may not.
  if (
    overlays.some((overlay) => !overlay.hasAttribute("data-page-search-scope"))
  ) {
    event.preventDefault();
    return;
  }

  const scope = overlays.at(-1) ?? doc;
  const inputs = Array.from(
    scope.querySelectorAll<HTMLInputElement>("input[data-search-shortcut]"),
  ).filter((input) => !input.disabled && !input.readOnly && isAvailable(input));
  const active = inputs.find((input) => input === doc.activeElement);
  const input = active ?? inputs[0];

  if (input) {
    input.focus();

    if (doc.activeElement === input) {
      input.select();
      event.preventDefault();
    }
  }
}
